import http from 'plugins/axios';

export default {
  //旧的账单接口
  // reqList(data) {
  //   return http.get({
  //     url: '/la/admin/transfer/list',
  //     data
  //   });
  // },
 
 //获取配置信息
  reqList({page,size,confKey=''}) {
    return http.get({
      url: `/la/admin/site/conf/list?page=${page}&size=${size}&confKey=${confKey}`,
  //  data:{confKey}
    });
  },
  //删除配置
  del(confKey){
    return http.post({
      url:`/la/admin/site/conf/del?confKey=${confKey}`
    })
  },
  create(siteConfDto) {
    return http.post({
      url: '/la/admin/site/conf/add',
      data:{...siteConfDto},
      // dataType: 'form'
    });
  },
  updateOne(siteConfDto){
    return http.post({
      url:'/la/admin/site/conf/update',
      data:{...siteConfDto}
    })
  },
  // transfer({userId,coin,amount}){
  //   return http.post({
  //     url:`/la/admin/public/transfer?userId=${userId}&coin=${coin}&amount=${amount}`
  //   })
  // },
  // getCoinTypes() {
  //   return http.get({
  //     url: '/la/admin/coin/allDisplay'
  //   });
  // }
};
